import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ovivio-logo',
  templateUrl: './ovivio-logo.component.html',
  styleUrls: ['./ovivio-logo.component.scss'],
  standalone: true,
})
export class OvivioLogoComponent {
  @Input() title: string = 'Activities';
}
